import React, { useState, useEffect} from "react";
import toast from "react-hot-toast";
import Loader from "@core/helper/Loader";

import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import PageHeader from "@core/components/pageHeader";
import UserList from "views/pages/user/UserList";
import AddUser from "views/pages/user/AddUser";
import APICall from "network/APICall";
import EndPoints from "network/Endpoints";
import { useLocation } from "react-router-dom";
import Utility from "@core/helper/utility";
import { useSelector } from "react-redux";

const User = () => {
  const [openModal, setOpenModal] = useState(false);
  const [type, setType] = useState("");
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [userList, setUserList] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [searchText, setSearchText] = useState("");
  const [pageNumber, setPageNumber] = useState(0);
  const [updateData, setUpdateData] = useState(null);
  const [totalRecord, setTotalRecord] = useState(0);
  const [permission, setPermission] = useState({});
  const { userData } = useSelector((state) => state.auth);
  const [role, setRole] = useState("");
  const location = useLocation();
  const handleDeleteModal = (id) => {
    if (id) {
      const payload = { id };
      APICall("delete", payload, EndPoints.deleteUser)
        .then((response) => {
          const { isError, message } = response.data;
          if (response.status === 200 && !isError) {
            toast.success(message);
            const filter = userList.filter((o) => o.user_id !== id);
            setUserList(filter);
            fetchUserList();
          }
        })
        .catch((error) => {
          return error;
        });
    }
    setDeleteOpen(!deleteOpen);
  };

  const handleOpen = (type, id) => {
    setSearchText("");
    setOpenModal(!openModal);
    setType(type);
    if (id) {
      const findList = userList.find((o) => o.user_id === id);

      setUpdateData(findList);
    }
  };
  useEffect(() => {
    if (userData.data.user.role === "2") {
      const user = Utility.getUserData({
        datastore:userData,
        activePath: location.pathname,
      });

      setPermission(user[1]);
    } else {
      setPermission({});
    }

    setRole(userData.data.user.role);
  }, [location.pathname, userData]);
  useEffect(() => {
    fetchUserList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchText, pageNumber, pageSize]);

  const fetchUserList = () => {
    Loader.isLoading(true);
    const payload = {
      pageNo: pageNumber + 1,
      limit: pageSize,
      orderBy: "ASC",
      searchText: searchText,
    };
    APICall("post", payload, EndPoints.getUserList)
      .then((response) => {
        const { result, totalCount } = response.data.data;
        if (response.status === 200 && result) {
          setUserList(result);
          setTotalRecord(totalCount);
        } else {
          setUserList([]);
        }
      
      })
      .catch((error) => {
       
        return error;
      })
      .finally(() => {
        Loader.isLoading(false);
      });
  };

  const submitUser = () => {
    fetchUserList();
  };

  return (
    <Grid container spacing={4}>
      <PageHeader
        title={
          <Typography variant="body1" sx={{ fontSize: "1.3rem !important" }}>
            User
          </Typography>
        }
      />
        {((permission.view && role === "2") || role === "1") && (
      <Grid item xs={12}>
        <UserList
          handleDeleteModal={handleDeleteModal}
          deleteOpen={deleteOpen}
          handleOpen={handleOpen}
          userList={userList}
          pageSize={pageSize}
          setPageSize={setPageSize}
          searchText={searchText}
          setSearchText={setSearchText}
          pageNumber={pageNumber}
          setPageNumber={setPageNumber}
          totalRecord={totalRecord}
          permission={permission}
          role={role}
        />
      </Grid>
        )}
      <AddUser
        open={openModal}
        toggle={handleOpen}
        type={type}
        heading={type === "add" ? "Add User" : "Update User"}
        onSubmitUser={submitUser}
        updateData={updateData}
        permission={permission}
        role={role}
      />
    </Grid>
  );
};

export default User;
